<!--
图表组件   // 已注册全局组件,全局标签 chart
a) 实现组件自动释放资源
b) 实现组件随windows的resize而自适应
c) TODO:侧边栏导致的resize还未实现

1. 属性参数
  id : DOM元素的Id  默认 chart
  className : 自定义class 默认 chart
  height : 高度  默认 100%
  width : 宽度  默认 100%
  themes : 主题  默认 shine
  * options : echarts的option数据  必填

2. 方法
  setOption(options)  // 当重新覆盖options数据后调用此方法，即echart setOptions的方法（option不合并）
-->

<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import echarts from 'echarts'
import resize from './mixins/resize'
import lang from './mixins/lang'
import 'echarts/theme/dark'
import 'echarts/theme/infographic'
import 'echarts/theme/macarons'
import 'echarts/theme/roma'
import 'echarts/theme/shine'
import 'echarts/theme/vintage'

export default {
  name: 'Chart',
  components: {},
  mixins: [resize, lang],
  props: {
    // chart DOM id
    id: {
      type: String,
      default: 'chart'
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    options: {
      type: Object,
      required: true
    },
    themes: {
      type: String,
      default: 'shine'
    }
  },
  data() {
    return {
      chart: null // 图标options数据
    }
  },
  computed: {},
  watch: {},
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  created() {},
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      const me = this;
      this.chart = echarts.init(document.getElementById(this.id), this.themes)
      this.chart.setOption(this.options, true)
      this.chart.on('click',function(params){
        me.$emit('chartClick',params)
      })
    },
    setOption(newOptions) {
      this.chart.setOption(newOptions, true)
    }
  }
}
</script>
<style scoped></style>
